"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _ShotTab = _interopRequireDefault(require("./ShotTab"));

var _TemplateTab = _interopRequireDefault(require("./TemplateTab"));

var _ScriptTab = _interopRequireDefault(require("./ScriptTab"));

var _DetailsTab = _interopRequireDefault(require("./DetailsTab"));

function TabDrawer(_ref) {
  var templates = _ref.templates,
      selectTemplate = _ref.selectTemplate,
      selectedTemplateIndex = _ref.selectedTemplateIndex,
      shots = _ref.shots,
      updateShots = _ref.updateShots,
      updateAssets = _ref.updateAssets,
      selectShot = _ref.selectShot,
      selectedShotIndex = _ref.selectedShotIndex,
      onTabSelect = _ref.onTabSelect,
      setModal = _ref.setModal,
      handleStoryboardFieldChange = _ref.handleStoryboardFieldChange,
      storyboard = _ref.storyboard,
      hasUpdatePermission = _ref.hasUpdatePermission;
  var assetIds = storyboard.assetIds,
      organisationId = storyboard.organisationId;
  return _react.default.createElement(_uiKit.Drawer, {
    isVertical: true,
    tabIcons: ['template', 'info', 'script', 'medialibrary', 'comments'],
    onTabSelect: onTabSelect
  }, _react.default.createElement(_TemplateTab.default, {
    templates: templates,
    selectedTemplateIndex: selectedTemplateIndex,
    selectTemplate: selectTemplate,
    hasUpdatePermission: hasUpdatePermission
  }), _react.default.createElement(_DetailsTab.default, {
    handleStoryboardFieldChange: handleStoryboardFieldChange,
    storyboard: storyboard,
    hasUpdatePermission: hasUpdatePermission
  }), _react.default.createElement(_ScriptTab.default, {
    selectShot: selectShot,
    selectedShotIndex: selectedShotIndex,
    shots: shots,
    updateShots: updateShots,
    setModal: setModal,
    hasUpdatePermission: hasUpdatePermission
  }), _react.default.createElement(_ShotTab.default, {
    assetIds: assetIds,
    updateAssets: updateAssets,
    organisationId: organisationId,
    hasUpdatePermission: hasUpdatePermission
  }), _react.default.createElement(_commonReact.CommentsTab, {
    tabTitle: "All Comments",
    showAddCommentButton: true
  }));
}

var _default = TabDrawer;
exports.default = _default;